import { ShiftRequest } from 'types/shift-requests';

const extractShiftId = (shiftRef: unknown): number | null => {
	if (shiftRef == null || shiftRef === '') return null;
	if (typeof shiftRef === 'number' && Number.isFinite(shiftRef)) return shiftRef;
	if (typeof shiftRef === 'string') {
		const match = shiftRef.match(/(\d+)$/);
		return match ? Number(match[1]) : null;
	}
	if (typeof shiftRef === 'object') {
		const shift = shiftRef as { id?: number | string; '@id'?: string };
		if (typeof shift.id === 'number' && Number.isFinite(shift.id)) return shift.id;
		if (shift.id != null) return extractShiftId(String(shift.id));
		if (shift['@id']) return extractShiftId(shift['@id']);
	}
	return null;
};

const toPickupShiftOption = (shift: unknown) => {
	if (!shift || typeof shift !== 'object') return null;
	const option = shift as Record<string, any>;
	const id = extractShiftId(option);
	if (id == null) return null;

	return {
		...option,
		id,
		startAt: option.startAt || option.start_at || option.start,
		endAt: option.endAt || option.end_at || option.end,
	};
};

export const getPickupRequestFormValues = (
	editRequest?: Pick<ShiftRequest, 'shiftRequest' | 'note'> | null
) => ({
	shiftId: extractShiftId(editRequest?.shiftRequest)?.toString() || '',
	notes: editRequest?.note || '',
});

export const mergePickupShiftOptions = (
	houseShifts: any[] = [],
	selectedShift: unknown,
	selectedShiftId?: string | number | null
) => {
	if (selectedShiftId == null || selectedShiftId === '') return houseShifts;

	const selectedId = String(selectedShiftId);
	const extra = toPickupShiftOption(selectedShift);
	if (!extra) return houseShifts;

	const remaining = houseShifts.filter(
		(shift) => String(shift.id) !== selectedId && String(extractShiftId(shift)) !== selectedId
	);

	return [extra, ...remaining];
};
